if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      
        this.handleErrorMessage();
      
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');
      
        const addonProductCheckboxes = document.querySelectorAll('.addon__product--checkbox');
      
        if (addonProductCheckboxes) {
          for (const checkbox of addonProductCheckboxes) {
            if (checkbox.checked) {
              const parentDiv = checkbox.closest('.addon__product--list-item');
              const colorSelect = parentDiv.querySelector('.addon__product--color-variant');
              const sizeSelect = parentDiv.querySelector('.addon__product--size-variant');
      
              const addonProductValue = parentDiv.querySelector('.addon__product--atc-button').value;
              const formData = new FormData();
              formData.append('quantity', 1);
              formData.append('id', addonProductValue);
      
              const config = fetchConfig('javascript');
              config.headers['X-Requested-With'] = 'XMLHttpRequest';
              delete config.headers['Content-Type'];
      
              config.body = formData;
      
              try {
                const response = await fetch(`${routes.cart_add_url}`, config);
                const data = await response.json();
      
                if (data.status) {
                  console.error('Cart error:', data.message);
                }
              } catch (error) {
                console.error('Error:', error);
              } finally {
                checkbox.checked = false;
                if (colorSelect) {
                  colorSelect.disabled = true;
                }
                if (sizeSelect) {
                  sizeSelect.disabled = true;
                }
              }
            }
          }
        }
      
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
      
        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
      
        try {
          const response = await fetch(`${routes.cart_add_url}`, config);
          const jsonResponse = await response.json();
          if (jsonResponse.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: jsonResponse.errors || jsonResponse.description,
              message: jsonResponse.message,
            });
            this.handleErrorMessage(jsonResponse.description);
      
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }
      
          if (!this.error)
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: jsonResponse,
            });
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  this.cart.renderContents(jsonResponse);
                });
              },
              { once: true }
            );
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(jsonResponse);
          }
        } catch (error) {
          console.error(error);
        } finally {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner').classList.add('hidden');
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
